module.exports = __webpack_public_path__ + "img/Ma.Maritime.Breakwaters.Rubble-mounded-crownwall.Rock.677c2e56.png";